module.exports = __webpack_public_path__ + "img/emerald.be5030ca.webp";